























import RootElement from '@/components/common/RootElement.vue';
import {Vue, Component, Model, Prop, Watch} from 'vue-property-decorator';
@Component({
  components: {RootElement}
})
export default class CheckBoxElement extends Vue {
  @Prop({default: 'div'})
  private tag!: string;

  @Prop({required: true}) private checkboxOptions!: any;
  @Prop() private disabled?: boolean;

  @Model('change') readonly value!: string;
  @Watch('value', {immediate: false, deep: false})
  theValue() {
    this.setValues(this.value);
  }
  @Watch('valueArr.length', {immediate: false, deep: false})
  length(next: number) {
    this.checkAllCheck(next);
    let totalCount = this.checkboxOptions.data.length;
    totalCount = this.checkboxOptions.hasAll ? totalCount - 1 : totalCount;
    this.$emit('change', this.valueArr.length === totalCount && this.checkboxOptions.hasAll ? 'ALL' : this.valueArr.toString());
  }
  private checkAll = true;
  private valueArr: string[] = [];

  private handleCheckAll(): void {
    if (!this.checkAll) {
      this.initValueArr();
    } else {
      this.valueArr = [];
    }
  }
  initValueArr() {
    this.valueArr = [];
    this.checkboxOptions.data.forEach((item: any, index: number) => {
      if (!this.checkboxOptions.hasAll || index !== 0) {
        this.valueArr.push(item.value);
      }
    });
  }
  private checkAllCheck(e: number): void {
    let length = this.checkboxOptions.data.length;
    length = this.checkboxOptions.hasAll ? length - 1 : length;
    if (e === length) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }
  private focus() {
    if (this.checkboxOptions.hasAll) {
      (this.$refs.checkbox_all as any)[0].focus();
    } else {
      (this.$refs.checkbox_no_all as any)[0].focus();
    }
  }
  private setValues(val: string) {
    if (val === 'ALL' && this.checkboxOptions.hasAll) {
      this.checkAll = true;
      this.initValueArr();
    } else {
      this.checkAll = false;
      this.valueArr = [];
      this.valueArr.push(...val.split(',').filter((item: string) => item !== ''));
    }
  }
  mounted() {
    this.setValues(this.value);
  }
}
